import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "The Fifth Dimension",
  date: new Date(2025, 3, 27),
  img: "/img/tesseract.jpeg",
  tracks: [
    {
      title: "Grey Sky Blues",
      src: "/songs/2025-04-27/grey_sky_blues.mp3",
      duration: 239.064,
    },
    {
      title: "Get Up & Go!",
      src: "/songs/2025-04-27/get_up_and_go.mp3",
      duration: 323.184,
    },
    {
      title: "How To Hug",
      src: "/songs/2025-04-27/how_to_hug.mp3",
      duration: 426.048,
    },
    {
      title: "Slowdown Town",
      src: "/songs/2025-04-27/slowdown_town.mp3",
      duration: 604.272,
    },
    {
      title: "Outside Intrigue",
      src: "/songs/2025-04-27/outside_intrigue.mp3",
      duration: 339.504,
    },
    {
      title: "Inside Doubt",
      src: "/songs/2025-04-27/inside_doubt.mp3",
      duration: 783.936,
    },
    {
      title: "Hopped Scotch",
      src: "/songs/2025-04-27/hopped_scotch.mp3",
      duration: 352.32,
    },
    {
      title: "Night Walker",
      src: "/songs/2025-04-27/night_walker.mp3",
      duration: 329.448,
    },
    {
      title: "Where We've Gone",
      src: "/songs/2025-04-27/where_weve_gone.mp3",
      duration: 343.752,
    },
    {
      title: "Palpable Beats",
      src: "/songs/2025-04-27/palpable_beats.mp3",
      duration: 677.112,
    },
    {
      title: "Not So Solid Ground",
      src: "/songs/2025-04-27/not_so_solid_ground.mp3",
      duration: 1328.784,
    },
    {
      title: "Dying Battery Bass Drop",
      src: "/songs/2025-04-27/dying_battery_bass_drop.mp3",
      duration: 601.248,
    },
    {
      title: "Dying Battery Redux",
      src: "/songs/2025-04-27/dying_battery_redux.mp3",
      duration: 1345.968,
    },
    {
      title: "Beach Comber Paradise",
      src: "/songs/2025-04-27/beach_comber_paradise.mp3",
      duration: 488.184,
    },
    {
      title: "Rocket Riders Club",
      src: "/songs/2025-04-27/rocket_riders_club.mp3",
      duration: 374.976,
    },
    {
      title: "Post-Industrial Complex",
      src: "/songs/2025-04-27/post_industrial_complex.mp3",
      duration: 462.72,
    },
    {
      title: "Random Eyes",
      src: "/songs/2025-04-27/random_eyes.mp3",
      duration: 2067.264,
    },
    {
      title: "Since You Said Goodbye",
      src: "/songs/2025-04-27/since_you_said_goodbye.mp3",
      duration: 674.064,
    },
  ],
};
export default album;
